Directives.ToolsCatalogDirective = function ToolsCatalogDirective() {

    // @ngInject
    function ToolsCatalogDirectiveControllerFunc($scope, $injector, $state, AppStates, ModalService, UiPersistenceService, UserService,
                                                 UsersManager, CompaniesManager, DeviceService, TemplatesViewService,
                                                 AnalyticsService, ReferralService, OnboardingService, Enums, AbTestService, FeaturesService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TopNavToolsDirectiveController';

        this.$state = $state;
        this.AppStates = AppStates;
        this.ModalService = ModalService;
        this.UiPersistenceService = UiPersistenceService;
        this.TemplatesViewService = TemplatesViewService;
        this.UsersManager = UsersManager;
        this.CompaniesManager = CompaniesManager;
        this.DeviceService = DeviceService;
        this.ReferralService = ReferralService;
        this.AnalyticsService = AnalyticsService;
        this.OnboardingService = OnboardingService;
        this.Enums = Enums;
        this.UserService = UserService;
        this.AbTestService = AbTestService;
        this.FeaturesService = FeaturesService;

        this.user = this.UsersManager.getCurrUser();
        this.showClientAccessibility = this.UserService.shouldShowClientAccessibilityTopNav(this.user);

        // referral

        ////////////////////////////////////////////////////////
        // TODO : Remove from here
        // Need to use existing 'hb-refer-friend' directive,
        // but we need to rafactor it so it will fit here as
        // well. For now, extracted the logic from there
        ////////////////////////////////////////////////////////
        this.showReferrAFriend = false;
        this.ReferralService.getCampaignDetails(this.user).then(function success(campaignDetails) {
            if (campaignDetails && campaignDetails.campaign_uid) {
                this.showReferrAFriend = true;
            }
        }.bind(this));
        ////////////////////////////////////////////////////////
        // END
        ////////////////////////////////////////////////////////

        // handle checked tools
        this.iosActive = !!this.user.isMobileActive();
        this.company = CompaniesManager.getCurrCompany();
        if (this.company.wasFullyFetched()) {
            this.gotCompany();
        }
        this.register(this.company, 'success', this.gotCompany);
        this.isMobile = this.DeviceService.checkIfMobileSize();

        if(this.isMobile) {
            this.mobileAppUrl = "https://jha8.app.link/honeybook_mobile_app";
        }

        /////////////////////////////////////////////////
        this.shouldShowAllTools = true;
        this.toolsExpanded = false;

        this.setToolsState();

        this.tools = [
            {
                analyticsEventName: 'templates',
                state: $state.href(this.AppStates.root_core_navigation_templates),
                icon: 'icon-hb-tool-templates',
                labelTranslation: 'MAIN_NAV.TOOLS._TEMPLATES_'
            },
            {
                analyticsEventName: 'bookkeeping - payments',
                state: $state.href(this.AppStates.root_core_navigation_reports_payments),
                icon: 'icon-hb-tool-bookkeeping',
                labelTranslation: 'MAIN_NAV.TOOLS._BOOKKEEPING_'
            },
            {
                analyticsEventName: 'calendar',
                state: $state.href(this.AppStates.root_core_navigation_calendar),
                icon: 'tools-catalog__icon--scheduling-cal icon-hb-nx-tool-calendar-42',
                labelTranslation: 'MAIN_NAV.TOOLS._CALENDAR_'
            },
            {
                analyticsEventName: 'reports',
                state: $state.href(this.AppStates.root_core_navigation_reports_analytics),
                icon: 'icon-hb-tool-reports',
                labelTranslation: 'MAIN_NAV.TOOLS._REPORTS_'
            },
            {
                analyticsEventName: 'covid-19',
                state: $state.href(this.AppStates.root_core_navigation_corona),
                icon: 'tools-catalog__icon--scheduling-cal icon-hb-nx-tool-COVID19-42',
                labelTranslation: 'MAIN_NAV.TOOLS._COVID_19_',
                shouldShowNew: false,
                shouldShow: function shouldShow() {
                    return !this.isMobile && this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.coronaDashboard);
                }.bind(this)
            },
            {
                analyticsEventName: 'scheduling',
                state: $state.href(this.AppStates.root_core_navigation_scheduling),
                icon: 'tools-catalog__icon--scheduling-cal icon-hb-nx-tool-calendar-scheduling-42',
                labelTranslation: 'MAIN_NAV.TOOLS._SCHEDULING_',
                cssClass: 'tools-catalog__item--hidden-for-mobile',
                shouldShowNew: true
            },
            {
                analyticsEventName: 'tasks',
                state: $state.href(this.AppStates.root_core_navigation_tasks),
                icon: 'icon-hb-tool-tasks',
                labelTranslation: 'MAIN_NAV.TOOLS._TASKS_'
            },
            {
                analyticsEventName: 'contact form',
                state: $state.href(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'contactForm'}),
                stateProps: {templateModelKey: 'contactForm'},
                icon: 'icon-hb-tool-contact-form',
                labelTranslation: 'MAIN_NAV.TOOLS._CONTACT_FORM_',
                shouldShow: function shouldShow() {
                    return this.user.isCompanyOwner();
                }.bind(this),
                isActive: function isActive() {
                    return this.contactFormActive;
                }.bind(this)
            },
            {
                analyticsEventName: 'gift card',
                state: $state.href(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'giftCard'}),
                stateProps: {templateModelKey: 'giftCard'},
                icon: 'tools-catalog__icon--gift-card icon-hb-nx-tool-gift-card-42',
                labelTranslation: 'MAIN_NAV.TOOLS._GIFT_CARD_',
                shouldShow: function shouldShow() {
					return this.user.isCompanyOwner() && this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.instantBookingGiftCards);
                }.bind(this),
				shouldShowNew: true
            },
            {
                analyticsEventName: 'iosApp',
                state: this.mobileAppUrl,
                openInNewTab: true,
                icon: 'icon-hb-tool-iOS',
                activeIcon: 'ios-icon-check',
                labelTranslation: 'MAIN_NAV.TOOLS._IOS_APP_',
                isActive: function isActive() {
                    return this.iosActive;
                }.bind(this),
                shouldShow: function shouldShow() {
                    return !this.user.is_mobile_active || this.toolsExpanded || this.shouldShowAllTools;
                }.bind(this),
                onClick: this.mobileAppClicked.bind(this)
            },
            {
                analyticsEventName: 'library',
                state: $state.href(this.AppStates.root_core_navigation_settings_companySettings_library),
                icon: 'icon-hb-tool-library',
                labelTranslation: 'MAIN_NAV.TOOLS._UPLOAD_FILES_'
            },
            {
                analyticsEventName: 'time_tracker',
                state: $state.href(this.AppStates.root_core_navigation_time_tracker),
                icon: 'icon-hb-tool-timetrack',
                labelTranslation: 'MAIN_NAV.TOOLS._TIME_TRACKER_'
            },
            {
                analyticsEventName: 'workflow',
                state: $state.href(this.AppStates.root_core_navigation_workflows),
                icon: 'icon-hb-tool-workflows',
                labelTranslation: 'MAIN_NAV.TOOLS._WORKFLOW_',
                cssClass: 'tools-catalog__item--hidden-for-mobile tools-catalog__item--show-expanded'
            },
            {
                analyticsEventName: 'referrals',
                state: !this.isMobile ?
                    $state.href(this.AppStates.root_core_navigation_invite_referrals) :
                    $state.href(this.AppStates.root_core_navigation_invite_tabs_mobile),
                icon: 'icon-hb-tool-benefits',
                labelTranslation: 'MAIN_NAV.TOOLS._REFERRAL_',
                cssClass: 'tools-catalog__item--show-expanded',
                shouldShow: function shouldShow() {
                    return this.showReferrAFriend;
                }.bind(this)
            },
            {
                analyticsEventName: 'batch email',
                state: $state.href(this.AppStates.root_core_navigation_batch_email),
                icon: 'icon-hb-tool-email',
                labelTranslation: 'MAIN_NAV.TOOLS._BATCH_EMAIL_',
                cssClass: 'tools-catalog__item--show-expanded tools-catalog__item--hide-on-mobile'
            },
            {
                analyticsEventName: 'community',
                state: $state.href(this.AppStates.root_network_opportunities),
                icon: 'icon-hb-tool-opportunities',
                labelTranslation: 'MAIN_NAV._COMMUNITY_',
                cssClass: 'tools-catalog__item--show-expanded',
                shouldShow: function shouldShow() {
                    return this.showClientAccessibility;
                }.bind(this),
            },
            {
                analyticsEventName: 'creatives',
                state: $state.href(this.AppStates.root_core_navigation_creatives),
                icon: 'icon-hb-tool-creative',
                labelTranslation: 'MAIN_NAV.TOOLS._CREATIVES_',
                cssClass: 'tools-catalog__item--show-expanded',
            }
        ];

    }

    var ToolsCatalogDirectiveController = Class(Controllers.BaseController, {
        constructor: ToolsCatalogDirectiveControllerFunc,

        gotCompany: function gotCompany(){
            this.contactFormActive = this.company.isContactFormActive();
            this.setToolsState();
        },

        setToolsState: function setToolsState() {
            if(this.user.isVendor() && !this.user.companyHasSubscription()) {
                this.shouldShowAllTools = false;
            } else {
                this.shouldShowAllTools = true;
            }
        },

        openIntakeForm: function openIntakeForm() {
            this.OnboardingService.openInProductIntakeForm(this.Enums.IntakeFormSource.tools);
        },

        itemClicked: function itemClicked(tool, e) {
            if (tool.onClick) {
                tool.onClick(e);
                return;
            }

            this.onItemClick();
        },

        mobileAppClicked: function mobileAppClicked(e) {
            this.onItemClick();

            // if we are not on mobile, open Mobile App Intro Modal
            if(!this.isMobile) {

                // don't do the default link behavior
                e.preventDefault();

                this.ModalService.openMobileAppIntroModal().finally(function(result){
                    this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.mobileAppIntro, {dontShow: true});
                }.bind(this));

            }
        }
    });

    return {
        scope: {
            show: '=show',
            onItemClick: '&'
        },
        templateUrl: 'angular/app/modules/core/features/top_nav/tools/tools_catalog_template.html',
        controller: ToolsCatalogDirectiveController,
        controllerAs: 'toolsCatalogVm',
        bindToController: true
    };
};
